import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AutoCarousel from "../Home/AutoCarousel";
import MultipleItems from "./CarouselTest";
import TestimonialsCarousel from "../Home/TestimonialsCarousel";



export default function EmployerZone() {
    const [employers, setEmployers] = useState([]);
    const [content, setContent] = useState([]);
    const [pricing, setPricing] = useState([]);

   
    const [organizationData, setOrganizationData] = useState([]);
    const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
      let isMounted = true;
      const controller = new AbortController();
  
      axios
        .get("api/home/get_organization_data", { signal: controller.signal })
        .then((res) => {
          if (!isMounted) return;
          if (res.data.status == "success") {
            setOrganizationData(res.data.data);
          } else {
            setOrganizationData([]);
          }
        })
        .catch((error) => {
          if (!isMounted) return;
          if (error.name !== "AbortError" && error.name !== "CanceledError") {
            console.error("Failed to load organization data:", error);
          }
        });
  
      window.scrollTo(0, 0);
  
      return () => {
        isMounted = false;
        controller.abort();
      };
    }, []);
  
  const [isScrollVisible, setIsScrollVisible] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    axios
      .get(constvar.api_url + "home/get_employer_carousel", {
        signal: controller.signal,
      })
      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") setEmployers(res.data.data || []);
      })
      .catch((error) => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load employer carousel:", error);
        }
      });

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  useEffect(() => {
    const onScroll = () => setIsScrollVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  
   useEffect(() => {
      let isMounted = true;
      const controller = new AbortController();
  
      window.scrollTo(0, 0);
      axios.get("/api/home/get_services", { signal: controller.signal }).then((res) => {
        if (!isMounted) return; //Guard skip state if unmounted
        if (res.data.status == "success") {
          setContent(res.data.content);
        } else {
          setContent([]);
        }
      }).catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError"  && error.name !== "CanceledError") {
          console.error("Failed to load about us:", error);
        }
      });
  
      // Cleanup: cancel request if component unmounts
      return () => {
        isMounted = false;
        controller.abort();
      };
    }, []);

   useEffect(() => {
      let isMounted = true;
      const controller = new AbortController();
  
      window.scrollTo(0, 0);
      axios.get("/api/home/get_pricing", { signal: controller.signal }).then((res) => {
        if (!isMounted) return; //Guard skip state if unmounted
        if (res.data.status == "success") {
          setPricing(res.data.pricing);
        } else {
          setPricing([]);
        }
      }).catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError"  && error.name !== "CanceledError") {
          console.error("Failed to load pricing:", error);
        }
      });
  
      // Cleanup: cancel request if component unmounts
      return () => {
        isMounted = false;
        controller.abort();
      };
    }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const carouselItems =
    employers.length > 0
      ? employers
      : Array.from({ length: 8 }, (_, i) => ({
          id: i,
          comp_name: "Company",
          imgUrl: "/default/default_company_logo.jpg",
          clientslug: "#",
        }));

    const handleTabClick = (e, targetId) => {
    e.preventDefault();
    setActiveTab(targetId);
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <React.Fragment>
       
      {/* ── Hero ─────────────────────────────────── */}
      <section className="sf-hero">
        <div className="sf-container-zone">
          <div className="sf-hero-content">
            <h1 className="sf-hero-title">
              Employer Zone.
            </h1>
            <p className="sf-hero-subtitle">
              Start your hiring journey with us! Create a free recruiter account or log in to post jobs, manage applications, and find the perfect candidates for your team.
            </p>
            <div className="extra-nav header-2-nav">
          <div className="extra-cell">
            <div className="header-nav-btn-section">
              <div className="twm-nav-btn-left">
                <Link to={"/login-employer"} className="twm-nav-post-a-job">
                  <i className="ri-briefcase-line"></i> Login
                </Link>
              </div>
              <div className="twm-nav-btn-right">
                <Link to={"/register-employer"} className="twm-nav-sign-up">
                  <i className="ri-login-box-line"></i> Sign Up
                </Link>
              </div>
            </div>
          </div>
            <p className="sf-hero-subtitle">
              Already have an account ?<Link to={"/login-employer"} className="twm-login"> Login</Link>
            </p>
          </div>
          </div>
        </div>
      </section>

{/* ── In-Page Local Tab Navigation ────────────────── */}
      <div className="sf-local-tabs-container">
        <div className="sf-container sf-local-tabs">
          <a 
            href="#our-services" 
            className={`sf-tab-item ${activeTab === "our-services" ? "active" : ""}`}
            onClick={(e) => handleTabClick(e, "our-services")}
          >
            Our Services
          </a>
          <a 
            href="#plans-and-pricing" 
            className={`sf-tab-item ${activeTab === "plans-and-pricing" ? "active" : ""}`}
            onClick={(e) => handleTabClick(e, "plans-and-pricing")}
          >
            Plans and Pricing

          </a>
          <a 
            href="#trusted-partner" 
            className={`sf-tab-item ${activeTab === "trusted-partner" ? "active" : ""}`}
            onClick={(e) => handleTabClick(e, "trusted-partner")}
          >
            Trusted Partner
          </a>
        </div>
      </div>

    <section id="our-services" className="sf-section sf-section-light">
      <div className="sf-container">
        <h1 className="sf-testimonials-title">
          Services We Provide
        </h1>
         <div className="row">
                  {content.length > 0
                    ? content.map((item, idx) => {
                        let colorName = ["sky", "yellow", "pink", "green"];
                        let titleWords = item.title.split(" ");
                        let firstWord = titleWords[0];
                        let remWords = titleWords.slice(1).join(" ");
                        return (
                          <div className="col-xl-4 col-lg-4 col-md-4">
                            <div className="twm-w-process-steps-2">
                              <div
                                className={`twm-w-pro-top bg-clr-${colorName[idx]}-light bg-${colorName[idx]}-light-shadow`}
                              >
                                <span
                                  className={`twm-large-number text-clr-${colorName[idx]}`}
                                >
                                  0{idx + 1}
                                </span>
                                <div className="twm-media">
                                  <span>
                                    <img src={item.imgUrl} alt={item.title} />
                                  </span>
                                </div>
                                <h4 className="twm-title">
                                  {firstWord}
                                  <br />
                                  {remWords}
                                </h4>
                                <p>{item.content}</p>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : ""}
                </div>
        </div>       
    </section>

    <section id="plans-and-pricing" className="sf-section sf-section-light">
        <div className="sf-container">
        <h1 className="sf-testimonials-title">
          Plans and Pricing
        </h1>
            <div className="row">
                  {pricing.length > 0
                    ? pricing.map((item, idx) => {
                        let colorName = ["sky", "yellow", "pink", "green"];
                        let titleWords = item.title.split(" ");
                        let firstWord = titleWords[0];
                        let remWords = titleWords.slice(1).join(" ");
                        return (
                          <div className="col-xl-4 col-lg-4 col-md-4">
                            <div className="twm-w-process-steps-2">
                              <div
                                className={`twm-w-pro-top bg-clr-${colorName[idx]}-light bg-${colorName[idx]}-light-shadow`}
                              >
                                <span
                                  className={`twm-large-number text-clr-${colorName[idx]}`}
                                >
                                  0{idx + 1}
                                </span>
                                <div className="twm-media">
                                  <span>
                                    <img src={item.imgUrl} alt={item.title} />
                                  </span>
                                </div>
                                <h4 className="twm-title">
                                  {firstWord}
                                  <br />
                                  {remWords}
                                </h4>
                                <p>{item.content}</p>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : ""}
          </div>
        </div>   
    </section>

    <TestimonialsCarousel />
    {/* <section className="sf-section sf-section-light">
      <div className="sf-container">
<MultipleItems />
</div>
</section> */}
    {/* ── Actively Recruiting Employers ────────── */}
      <section id="trusted-partner"className="sf-section sf-section-light">
        <div className="sf-container">
          <AutoCarousel title="Trusted By Leading Companies">
            {carouselItems.map((emp) => (
              <Link
                key={emp.id}
                to={emp.clientslug !== "#" ? `/company/${emp.clientslug}` : "/"}
                className="sf-employer-logo"
              >
                <img src={emp.imgUrl} alt={emp.comp_name} />
              </Link>
            ))}
          </AutoCarousel>
        </div>
      </section>

        <section>
             {/* ── Map ── */}
                <div className="sf-cp-map-wrap">

                <iframe src={organizationData.google_map_code}
                height="420"  
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade">
                </iframe>

                </div>       
        </section>




      {/* ── Scroll-to-top ────────────────────────── */}
      {isScrollVisible && (
        <button
          className="sf-scroll-top"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <i className="fa fa-angle-up" />
        </button>
      )}
    </React.Fragment>
  );
}
